import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { User } from '../../core/models/user';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { getFirebaseBackend } from 'src/app/authUtils';
import { AuthorizePaymentService } from '../../services/payment/payment.service';
import { BillComService } from '../../services/payment/billcom.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CampaignService } from '../../services/campaigns/campaign.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { STATES_SMALL } from 'src/app/shared/constants';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { BillingService } from 'src/app/services/billing/billing.service';
import { NotPayedLeadsComponent } from '../billing/not-payed-leads/not-payed-leads.component';

@Component({
	selector: 'app-billing-authorize',
	templateUrl: './billing-authorize.component.html',
	styleUrls: ['./billing-authorize.component.scss'],
})
export class BillingAuthorizeComponent implements OnInit {
	@Input() stripe_back: string = '';
	@Input() alertedIn: boolean = false;
	@Output() alerted = new EventEmitter<boolean>();

	@ViewChild('notPayedComponent') notPayedComponent: NotPayedLeadsComponent;
	@ViewChild('tableUnpaid') tableUnpaid: DatatableComponent;
	@ViewChild('numLead') numLead: ElementRef;
	@ViewChild('agent') agent: ElementRef;
	@ViewChild('alias') alias: ElementRef;
	@ViewChild('prospect') prospect: ElementRef;
	@ViewChild('campaign') campaign: ElementRef;
	@ViewChild('tablePaid') tablePaid: DatatableComponent;
	@ViewChild('numLeadP') numLeadP: ElementRef;
	@ViewChild('agentP') agentP: ElementRef;
	@ViewChild('aliasP') aliasP: ElementRef;
	@ViewChild('prospectP') prospectP: ElementRef;
	@ViewChild('campaignP') campaignP: ElementRef;
	@ViewChild('AmountP') AmountP: ElementRef;
	addCustomerForm;
	copied = false;

	user: User = null;
	fromDate: NgbDate | null;
	toDate: NgbDate | null;
	campaigns = [];
	showPayed: boolean = false;
	loading = false;
	approved = [];
	notPayedLeads = [];
	searchCampaign = 'All';
	hoveredDate: NgbDate | null = null;
	selectedLead: any;
	prices: any[];
	selectedCost: string;
	loadingPrices: boolean;
	loadingCharge: boolean;

	//Table
	columnMode = ColumnMode;
	rowsUnpayed = [];
	rowsPayeds = [];
	SearchUnpayed = [];
	SearchPaid = [];

	// Authorize.net
	customerForm: FormGroup;
	states = STATES_SMALL;

	// Bill.com ACH
	achForm: FormGroup;

	constructor(private router: Router, private dataService: OldDataService, public authenticationService: AuthenticationService, private calendar: NgbCalendar, private modalService: NgbModal, public formatter: NgbDateParserFormatter, public utils: UtilsService, public paymentSrv: AuthorizePaymentService, private formBuilder: FormBuilder, private userSrv: UserService, private campaignSrv: CampaignService, private billingSrv: BillingService, private billcomSrv: BillComService) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.fromDate = calendar.getToday();
		this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 10);
		this.toDate = calendar.getToday();
		this.selectedCost = null;
		this.loadingPrices = false;
		this.loadingCharge = false;

		this.achForm = this.formBuilder.group({
			nameOnAccount: ['Agatha Ffringe', Validators.required],
			bankName: ['Bank of America', Validators.required],
			routingNumber: ['074000010', [Validators.required, Validators.pattern('^[0-9]{9}$')]],
			accountNumber: ['111222333', [Validators.required, Validators.pattern('^[0-9]+$')]],
			accountType: ['CHECKING', Validators.required],
		});

		this.customerForm = this.formBuilder.group({
			cardNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
			expMonth: ['', [Validators.required, Validators.pattern('^[0-9]{2}$')]],
			expYear: ['', [Validators.required, Validators.pattern('^[0-9]{2}$')]],
			cvv: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			company: [''],
			address: ['', Validators.required],
			city: ['', Validators.required],
			state: ['', Validators.required],
			zip: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
			country: ['', Validators.required],
			phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
			customerType: [''],
			customerDescription: [''],
			email: ['', [Validators.required, Validators.email]],
		});
	}

	ngOnInit() {
		switch (this.stripe_back) {
			case 'cancel':
				if (!this.alertedIn) {
					Swal.fire({
						title: 'Card verification canceled',
						text: '',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					}).then((data) => {
						this.stripe_back = '';
						this.alerted.emit(true);
					});
				}
				break;
			case 'success':
				if (!this.alertedIn) {
					Swal.fire({
						title: 'Card verification success',
						text: '',
						showCancelButton: false,
						confirmButtonText: 'Ok',
					}).then((data) => {
						this.alerted.emit(true);
					});
				}

				break;

			default:
				break;
		}
	}

	getAllApproved() {
		this.showPayed = false;
		this.loading = true;

		this.paymentSrv.get_all_approved_not_paid().subscribe((response: any) => {
			const data = response.body;
			if (data) {
				if (data.records && data.records.length && !data.error) {
					this.approved = [];
					for (let lead of data.records) {
						this.approved.push(lead);
					}
					this.notPayedLeads = this.approved.filter((lead) => lead.payed === 'F' || lead.payed === 'P');
					this.rowsUnpayed = this.notPayedLeads;
					this.SearchUnpayed = this.rowsUnpayed;
					this.loading = false;
				} else if (data.error) {
					if (data.status && data.status === 401) {
						location.reload();
						this.loading = false;
					}
				} else {
					this.loading = false;
				}
			} else {
				this.loading = false;
			}
		});
	}

	editCampaign(id) {
		this.router.navigate(['/campaign-edit'], {
			queryParams: { id: id, from: 'billing' },
		});
	}

	freeLeadModal(content, lead) {
		this.selectedLead = lead;
		this.modalService
			.open(content, {
				ariaLabelledBy: 'modal-basic-title',
				centered: true,
			})
			.result.then(
				(result) => {
					//this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					// this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
				}
			);
	}

	setFreeLead(free_type) {
		const payload = {
			leadId: this.selectedLead.id,
			employee: this.user.Login,
			free_type: free_type,
			prospect_company: this.selectedLead.prospect_company,
			appt_date: this.selectedLead.date_generated,
		};
		Swal.fire({
			title: 'Set as Free',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.billingSrv.setAsFree(payload).subscribe((data: any) => {
					this.getAllApproved();
					this.modalService.dismissAll();
					Swal.fire({
						title: 'Success',
						text: 'The lead was charged successfuly',
						showCancelButton: false,
						confirmButtonText: 'Ok',
						cancelButtonText: 'Cancel',
					});
				});
			},
		});
	}

	setPayedLead() {
		let selectedUser: any;
		Swal.fire({
			title: 'Sending Email',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.userSrv.getUserByAlias(this.selectedLead.alias).subscribe((data: any) => {
					selectedUser = data.body;
					const payload = {
						user_id: selectedUser.id,
						leadId: this.selectedLead.id,
						normal_amount: this.selectedLead.lead_cost,
						paidBy: this.selectedLead.alias,
						employee: this.user.Login,
						prospect_company: this.selectedLead.prospect_company,
						appt_date: this.selectedLead.date_generated,
					};
					this.billingSrv.setAsPayed(payload).subscribe((data: any) => {
						this.modalService.dismissAll();
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'The lead was charged successfuly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
						this.getAllApproved();
					});
				});
			},
		});
	}

	warningCharge(content: TemplateRef<any>, lead: any) {
		this.selectedLead = lead;
		this.getPrices();
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				this.selectedCost = '';
				this.loadingCharge = false;
			}
		);
		Swal.fire({
			title: `Charge $${lead.lead_cost}`,
			text: `To alias ${lead.alias} from campaign ${lead.campaign_name}`,
			showCancelButton: true,
			confirmButtonText: 'Charge',
		}).then((data) => {
			if (data.value) {
				this.chargeAuthorizeNet();
			}
		});
	}

	chargeAuthorizeNet() {
		this.loadingCharge = true;
		this.selectedLead.lead_cost = this.selectedCost.split(' - ')[1];

		const payload = {
			profileId: this.selectedLead.authorize_id,
			payment_id: this.selectedLead.payment_id,
			amount: this.selectedLead.lead_cost,
			leadId: this.selectedLead.id,
			user_id: this.selectedLead.user_id,
			appt_date: this.selectedLead.date_generated,
			prospect_company: this.selectedLead.prospect_company,
		};
		this.loadingCharge = false;
		Swal.fire({
			title: 'Charging',
			text: 'We are Charging the lead',
			confirmButtonText: 'Ok',
			didOpen: () => {
				this.modalService.dismissAll();
				Swal.showLoading();
				this.paymentSrv.charge_customer(payload).subscribe(
					(data: any) => {
						if (data.body.success) {
							this.getAllApproved();
							Swal.close();
							Swal.fire({
								title: `Success`,
								icon: 'success',
								text: `Lead ${this.selectedLead.id} was charged successfuly`,
								showCancelButton: false,
								confirmButtonText: 'Ok',
							});
						} else {
							Swal.fire({
								title: `Error`,
								icon: 'error',
								text: `There was an error on charge Lead ${this.selectedLead.id}`,
								showCancelButton: false,
								confirmButtonText: 'Ok',
							}).then((data) => {
								this.getAllApproved();
							});
						}
					},
					(error) => {
						console.error(error);
					}
				);
			},
		});
	}

	errorTransaction(error: string) {
		Swal.fire({
			title: 'Error',
			text: error,
			showCancelButton: false,
			confirmButtonText: 'ok',
		});
	}
	getCellClassCampaign({ row, column, value }): any {
		return {
			' back-cell-gray content-point': row['id'] > 0,
		};
	}
	getCellClassOptions({ row, column, value }): any {
		return {
			' cellForButtons back-cell-text-right': row['id'] > 0,
		};
	}
	summaryFor(opcion: number) {
		var totalCostPayed: number;
		var totalCostUnpayed: number;
		var listNumber: number[];
		totalCostPayed = 0;
		totalCostUnpayed = 0;

		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0,
		});

		switch (opcion) {
			case 1: {
				listNumber = this.rowsUnpayed.map((row) => row['lead_cost']);
				listNumber = listNumber.map(Number);
				totalCostUnpayed = listNumber.reduce((res, cell) => (res += cell), 0);
				return formatter.format(totalCostUnpayed);
			}
			case 2: {
				listNumber = this.rowsPayeds.map((row) => row['amount']);
				listNumber = listNumber.map(Number);
				totalCostPayed = listNumber.reduce((res, cell) => (res += cell), 0);
				return formatter.format(totalCostPayed);
			}
		}
	}
	updateFilter(event, opcion) {
		const val = event.target.value.toLowerCase();
		let answer_filter: any[];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.rowsUnpayed;
		} else {
			searchWithFilters = this.SearchUnpayed;
		}
		switch (opcion) {
			case 1: //id
				answer_filter = searchWithFilters.filter(function (d) {
					return d.id.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 2: //generated_by
				answer_filter = searchWithFilters.filter(function (d) {
					return d.generated_by.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 3: //alias
				answer_filter = searchWithFilters.filter(function (d) {
					return d.alias.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 4: //prospect_company
				answer_filter = searchWithFilters.filter(function (d) {
					return d.prospect_company.toLowerCase().indexOf(val) !== -1 || !val;
				});

				break;
			case 5: //campaign_name
				answer_filter = searchWithFilters.filter(function (d) {
					return d.campaign_name.toLowerCase().indexOf(val) !== -1 || !val;
				});
			default:
				break;
		}

		this.rowsUnpayed = answer_filter;
		this.tableUnpaid.offset = 0;
	}

	cleanFiltersSearch() {
		this.numLead.nativeElement.value = '';
		this.agent.nativeElement.value = '';
		this.alias.nativeElement.value = '';
		this.prospect.nativeElement.value = '';
		this.campaign.nativeElement.value = '';

		this.rowsUnpayed = this.SearchUnpayed;
	}

	addAuthorizeCustomerModal(content, lead) {
		this.customerForm.markAsUntouched();
		this.customerForm.get('email').patchValue(lead.email);
		this.customerForm.get('country').patchValue('USA');
		this.selectedLead = lead;

		this.modalService.open(content, {
			ariaLabelledBy: 'modal-basic-title',
			centered: true,
			size: 'lg',
		});
	}

	submitAddCustomerForm() {
		this.customerForm.markAllAsTouched();

		if (this.customerForm.valid) {
			const form = this.customerForm.value;
			const payload = {
				cardNumber: form.cardNumber,
				expDate: `20${form.expYear}-${form.expMonth}`,
				cvv: form.cvv,
				firstName: form.firstName,
				lastName: form.lastName,
				address: form.address,
				city: form.city,
				state: form.state,
				zip: form.zip,
				country: form.country,
				phoneNumber: form.phoneNumber,
				email: form.email,
				customerDescription: this.selectedLead.alias,
			};

			Swal.fire({
				title: 'Saving',
				text: 'Saving customer credit card',
				confirmButtonText: 'Ok',
				didOpen: () => {
					Swal.showLoading();
					this.paymentSrv.create_customer(payload).subscribe(
						(data) => {
							this.notPayedComponent.getNotPayedLeads();
							this.modalService.dismissAll();
							Swal.close();
							Swal.fire({
								title: 'Success',
								icon: 'success',
								text: 'Customer credit card save successfully.',
								showCancelButton: false,
								confirmButtonText: 'Ok',
							});
						},
						(error) => {
							this.errorTransaction(error);
						}
					);
				},
			});
		} else {
			console.error('Not Valid Form');
		}
	}

	isControlInvalid(controlName: string): boolean {
		const control = this.customerForm.get(controlName);
		return control ? control.invalid && (control.dirty || control.touched) : false;
	}

	isAchControlInvalid(controlName: string): boolean {
		const control = this.achForm.get(controlName);
		return control ? control.invalid && (control.dirty || control.touched) : false;
	}

	openSetAchModal(content: any, lead: any) {
		this.achForm.markAsUntouched();
		this.selectedLead = lead;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' });
	}

	submitAchForm() {
		this.achForm.markAllAsTouched();
		if (!this.achForm.valid) return;

		const form = this.achForm.value;
		const payload = {
			userId: this.selectedLead.user_id,
			email: this.selectedLead.email,
			customerName: this.selectedLead.alias,
			nameOnAccount: form.nameOnAccount,
			bankName: form.bankName,
			routingNumber: form.routingNumber,
			accountNumber: form.accountNumber,
			accountType: form.accountType,
		};

		Swal.fire({
			title: 'Saving',
			text: 'Setting up ACH profile in Bill.com',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.billcomSrv.create_ach_profile(payload).subscribe(
					(_data: any) => {
						this.notPayedComponent.getNotPayedLeads();
						this.modalService.dismissAll();
						Swal.close();
						Swal.fire({ title: 'Success', icon: 'success', text: 'ACH profile saved successfully.', confirmButtonText: 'Ok' });
					},
					(error) => {
						this.errorTransaction(error);
					}
				);
			},
		});
	}

	getPrices() {
		this.loadingPrices = true;
		this.campaignSrv.getCampaignPrices(this.selectedLead.campaign_id).subscribe((data: any) => {
			this.prices = data.body;
			this.loadingPrices = false;
			const leadCost = this.prices.find((price) => price.description === 'Lead Cost');
			this.selectedCost = `${leadCost.description} - ${leadCost.price}`;
		});
	}
}
